import { merge } from '../../../helper';

import exLanguage from '../../../language';
import * as exElement from '../../element';

import * as exListing from '../listing';
import * as exUtils from '../utils';

import { start as startUpload } from './upload';

// ----------------------------------------------------------------------------

function start(config: Record<string, any> = {}): Record<string, any> {
    const defConfig: Record<string, any> = {};
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Function Modal Action Success
    const fnModalActionSuccess = function (): void {
        // Get table data
        const rowsData = datatable.getData();
        // If there is no row data
        if (rowsData.length <= 0) {
            return;
        }

        // If using function success
        if (typeof config.fnSuccess === 'function') {
            config.fnSuccess(rowsData);
        }
    };

    // Function Modal Hidden
    const fnModalHidden = function (): void {
        datatable.destroy();
    };

    // Function Upload Success
    const fnUploadSuccess = function (files): void {
        // Get table data
        const rowsData = datatable.getData();

        // Update list data
        const listData = exUtils.mergeFileData(rowsData, files);

        // Clear
        datatable.clear();
        // Add Rows
        datatable.rows.add(listData).draw();

        // Button Import
        elements.modal.elements.buttons[0].element.disabled = listData.length <= 0;
    };

    // ------------------------------------------------------------------------

    //
    const elements = startUpload({
        modal: {
            merge: defConfig.modal,
            buttons: [
                {
                    class: {
                        new: 'btn btn-primary',
                    },
                    attr: {
                        disabled: '',
                    },
                    html: exLanguage.line('general.import'),
                    fnAction: fnModalActionSuccess,
                },
                {
                    html: exLanguage.line('general.cancel'),
                },
            ],
            modalEvent: {
                hidden: fnModalHidden,
            },
        },
        upload: {
            merge: defConfig.upload,
            change: {
                fnSuccess: fnUploadSuccess,
            },
        },
    });

    // ------------------------------------------------------------------------

    // Create element (divider)
    const elDivider = exElement.create({
        tag: 'hr',
    });
    elements.modal.child(elDivider);

    // ------------------------------------------------------------------------

    // Create element (listing)
    const datatable = exListing.create({
        merge: defConfig.listing,
        datatable: {
            destroy: true,
        },
        container: {
            parent: elements.modal.elements.body,
        },
    });
    elements.datatable = datatable;

    // ------------------------------------------------------------------------

    // Return
    return elements;
}

// ----------------------------------------------------------------------------

export { start };
